import React from 'react';
import { Mail, Instagram, ArrowLeft, Send } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './ContactPage.css';

const ContactPage: React.FC = () => {
  const handleEmailContact = () => {
    const email = 'echosoflunaria@gmail.com';
    const subject = 'Contact from Echoes Of Lunaria Website';
    const body = 'Hello Echoes Of Lunaria team,\n\nI would like to get in touch regarding...\n\nBest regards,';
    
    // For mobile devices, try to open Gmail app, fallback to default mail client
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Check if on mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
      // Try Gmail app first, fallback to default mail client
      window.open(mailtoUrl, '_blank');
    } else {
      // Open Gmail web interface
      window.open(gmailUrl, '_blank');
    }
  };

  const handleInstagramContact = () => {
    const instagramUrl = 'https://www.instagram.com/echos_oflunaria/';
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
      // Try to open Instagram app first
      window.location.href = 'instagram://user?username=echos_oflunaria';
      // Fallback to web version after a short delay
      setTimeout(() => {
        window.open(instagramUrl, '_blank');
      }, 1000);
    } else {
      // Open Instagram web version
      window.open(instagramUrl, '_blank');
    }
  };

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      
      <div className="contact-page">
        <div className="contact-container">
          {/* Header Section */}
          <div className="contact-header">
            <Link to="/" className="back-button">
              <ArrowLeft size={20} />
              <span>Back to Home</span>
            </Link>
            
            <div className="contact-title-section">
              <h1 className="contact-main-title">Get In Touch</h1>
              <p className="contact-subtitle">
                We'd love to hear from you. Choose your preferred way to connect with the Echoes Of Lunaria team.
              </p>
            </div>
          </div>

          {/* Contact Options */}
          <div className="contact-options">
            
            {/* Email Contact Section */}
            <div className="contact-option email-option">
              <div className="contact-option-content">
                <div className="contact-icon-wrapper email-icon">
                  <Mail size={32} />
                </div>
                
                <div className="contact-text">
                  <h2 className="contact-option-title">Contact Us Via Email</h2>
                  <p className="contact-option-description">
                    Send us a detailed message and we'll get back to you as soon as possible. 
                    Perfect for feedback, questions, or collaboration inquiries.
                  </p>
                  <div className="contact-email-info">
                    <span className="email-address">echosoflunaria@gmail.com</span>
                  </div>
                </div>
                
                <button 
                  onClick={handleEmailContact}
                  className="contact-button email-button"
                >
                  <Send size={20} />
                  <span>Send Email</span>
                </button>
              </div>
            </div>

            {/* Instagram Contact Section */}
            <div className="contact-option instagram-option">
              <div className="contact-option-content">
                <div className="contact-icon-wrapper instagram-icon">
                  <Instagram size={32} />
                </div>
                
                <div className="contact-text">
                  <h2 className="contact-option-title">Contact Us Via Instagram</h2>
                  <p className="contact-option-description">
                    Follow us for updates, behind-the-scenes content, and quick messages. 
                    Direct message us for instant communication and community updates.
                  </p>
                  <div className="contact-instagram-info">
                    <span className="instagram-handle">@echos_oflunaria</span>
                  </div>
                </div>
                
                <button 
                  onClick={handleInstagramContact}
                  className="contact-button instagram-button"
                >
                  <Instagram size={20} />
                  <span>Open Instagram</span>
                </button>
              </div>
            </div>
            
          </div>

          {/* Additional Info */}
          <div className="contact-footer-info">
            <div className="contact-info-card">
              <h3>What can you contact us about?</h3>
              <ul>
                <li>📚 Feedback on chapters and storylines</li>
                <li>💡 Suggestions for improvements</li>
                <li>🐛 Technical issues or bug reports</li>
                <li>🤝 Collaboration opportunities</li>
                <li>❓ General questions about the story</li>
                <li>💬 Community discussions and ideas</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ContactPage;